import { ConfigByCountry, GetUserDropShipRes, ShipBillInfoRes, UserinfoRes } from '@/types/user';
import { http } from './http.service';
class UserService {
  getUserInfo = async () => {
    const response = await http.get<UserinfoRes>(`/api/user/getCurrentUser`);
    return response;
  };

  getShipBillInfo = async () => {
    const response = await http.get<ShipBillInfoRes>(`/api/user/getUserBTAndST`);
    return response;
  };

  getUserDropShip = async () => {
    const response = await http.get<GetUserDropShipRes>(`/api/user/getUserDropShip`);
    return response;
  };

  getConfigByCountry = async () => {
    const response = await http.get<ConfigByCountry[]>(`/api/function/config/detail`);
    return response;
  };
}

export const userService = new UserService();
